var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/web.immediate.js
// module id = 597
// module chunks = 48 49 50 51